import React, { type FC, type ReactNode } from 'react';
import { BrandPageBackground, LoadingBackground, Spinner } from '@seddi/ui-kit';
import { useAppLoad } from './appLoad.hooks';
import backgroundImage from './background_image.png';

type AppLoadProps = {
  children: ReactNode;
};

export const AppLoad: FC<AppLoadProps> = ({ children }) => {
  const { isLoaded } = useAppLoad();
  return isLoaded ? (
    children
  ) : (
    <BrandPageBackground image={backgroundImage}>
      <LoadingBackground>
        <Spinner type="circle" />
      </LoadingBackground>
    </BrandPageBackground>
  );
};
